import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PaymentFilter from '../../components/filters/PaymentFilter';

import loadPayments from '../../actions/payments';

class PaymentFilterContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(query) {
    const { loadPayments: refresh } = this.props;
    refresh(query);
  }

  render() {
    return (
      <PaymentFilter onChange={this.onChange} />
    );
  }
}

PaymentFilterContainer.propTypes = {
  loadPayments: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { pagination: { clients: pagination }, entities: { clients } } = state;
  return {
    clients: pagination.ids ? pagination.ids.map((id) => clients[id]) : [],
  };
};

export default connect(mapStateToProps, { loadPayments })(PaymentFilterContainer);
